/**
 * PATH: packages/job-hub/src/jobs/qa/qaParticipantRoles.ts
 * FILE_ID: JOBHUB-QA-PARTICIPANT-ROLES-001
 * PURPOSE: Shared role labels for job QA participants.
 */
export const QA_PARTICIPANT_ROLES: Array<[string, string]> = [
  ['supervisor', 'Supervisor'],
  ['installer', 'Installer'],
  ['pm', 'Project Manager'],
  ['qa_manager', 'QA Manager'],
  ['builder_rep', 'Builder Representative'],
  ['auditor', 'Auditor'],
  ['viewer', 'Viewer'],
]

export function qaRoleLabel(value: string): string {
  return QA_PARTICIPANT_ROLES.find(([role]) => role === value)?.[1] ?? value
}
